export default class UTMCookieNames {
    static readonly UtmSource = 'utm_source';
    static readonly UtmMedium = 'utm_medium';
    static readonly UtmCampaign = 'utm_campaign';
    static readonly UtmTerm = 'utm_term';
    static readonly UtmContent = 'utm_content';
}
